import React, { useState, useEffect, Component } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment/moment";
import "../pagination/pagination.css";
import Pagination from "../pagination/pagination";
import { IoAddSharp } from "react-icons/io5";
import Select from "react-select";
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from "../../services/apiService";
import Modal from 'react-bootstrap/Modal';
import { GetCountries } from "react-country-state-city";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const CustomerListing = () => {
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [selectedRow, setSelectedRow] = useState(null);
    const apiService = new LeaseApiService();
    const [FilterTab, setFilterTab] = useState(true);
    const [previewModal, setPreviewModal] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [countriesList, setCountries] = useState([]);
    const [sourceList, setSourceList] = useState([]);
    const [customerTypeList, setCustomerTypeList] = useState([]);
    const [salesPersonList, setSalesPersonList] = useState([]);
    const [leadStatus, setLeadStatus] = useState([]);
    const [contextMenu, setContextMenu] = useState(null);
    let navigate = useNavigate();
    const [formData, setFormData] = useState({
        fullName: "",
        contactid: "",
        contactNo: "",
        source: "",
        type: "",
        salesPerson: "",
        email: "",
        id: "",
        salecustomer: "",
        leaseCustomer: "",
        prospectlevel: "",
        leadStatus: "",
        followupcheck: "",
        followupfrom: "",
        followtoCheck: "",
        followupto: "",
        createdfromcheck: "",
        createdfrom: "",
        createdtocheck: "",
        createdto: "",
    })
    useEffect(() => {
        fetchDropdownData()
        GetCountries().then((result) => {
            setCountries(result);
        });
    }, []);

    useEffect(() => {
        getItems();
    }, [])
    useEffect(() => {
        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);
        return () => window.removeEventListener('click', handleClickOutside);
    }, []);

    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'CustSource,SalesPersons,CustomerType');
            const res = await apiService.getApiParamater('CUSTOMER_MULTI', `?${params.toString()}`);
            setSourceList(res?.data?.dropdowns?.CustSource)
            setCustomerTypeList(res?.data?.dropdowns?.CustomerType)
            setSalesPersonList(res?.data?.dropdowns?.SalesPersons)
            setLeadStatus([{ value: 'All', text: 'All' }, { value: 'Open', text: 'Open' }, { value: 'In Process', text: 'In Process' }, { value: 'Closed', text: 'Closed' }]);

        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append("PageNo", newPageNo || 1);
            params.append("PageSize", pageSize || 20);
            params.append("FullName", formData?.fullName || "");
            params.append("LeadStatus", formData?.leadStatus?.label || "");
            params.append("ContactID", formData?.contactid || "");
            params.append("CustomerType", formData?.type?.label || "");
            params.append("Nationality", selectedCountry?.label || "");
            params.append("Email", formData?.email || "");
            params.append("ContactNo", formData?.contactNo || "");
            params.append("Source", formData?.source?.label || "");
            params.append("SalesPerson", formData?.salesPerson?.label || "");
            params.append("IsSaleCustomer", formData?.salecustomer);
            params.append("IsLeaseCustomer", formData?.leaseCustomer);
            params.append("IsProspectLevel", formData?.prospectlevel);
            const res = await apiService.getApiParamater("GET_CUSTOMER", `?${params.toString()}`);
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching items:", error);
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2)
            ? 0
            : momentDate1.isBefore(momentDate2)
                ? -1
                : 1;
    }
    const columnDefs = [
        {
            headerName: '', field: 'recordId', cellRenderer: BtnCellRenderer, pinned: 'left',
            cellRendererParams: {
                clicked: function (field, exp2) {
                    handleMenuAction(field, exp2);
                },
            }, width: 30,
        },
        { headerName: "Contact ID", field: "customerNo", filter: true, floatingFilter: true, suppressMovable: true, width: 120, pinned: "left", },
        { headerName: "Name", field: "customerName", filter: true, floatingFilter: true, suppressMovable: true, width: 250, pinned: "left", },
        { headerName: "Mobile No", field: "contactNo", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Email", field: "emailId", filter: true, floatingFilter: true, suppressMovable: true, width: 250, },
        { headerName: "Source", field: "source", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Country", field: "country", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "City", field: "city", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "Sales Person", field: "salesPerson", filter: true, floatingFilter: true, suppressMovable: true, width: 150, },
        { headerName: "CreatedOn", field: "createdOn", filter: true, floatingfilter: true, valueFormatter: dateFormatter, comparator: dateComparator, suppressMovable: true, width: 136, },
        { headerName: "CreatedBy", field: "createdBy", filter: true, floatingFilter: true, suppressMovable: true, width: 250, },
        { headerName: "Project", field: "unitNo", filter: true, floatingFilter: true, suppressMovable: true, width: 100, },
    ]
    const handlenew = () => {
        navigate("/Customer/Property/Master/Customer/Create");
    }
    const handleEdit = (rowsData) => {
        if (rowsData) {
            navigate(`/Customer/Property/Master/Customer/Update`, { state: rowsData });
        }
    }
    const handleClearFilters = () => {
        setFormData({
            fullName: "",
            contactid: "",
            contactNo: "",
            source: "",
            type: "",
            salesPerson: "",
            email: "",
            id: "",
            salecustomer: "",
            leaseCustomer: "",
            prospectlevel: "",
            leadStatus: "",
            followupcheck: "",
            followupfrom: "",
            followtoCheck: "",
            followupto: "",
            createdfromcheck: "",
            createdfrom: "",
            createdtocheck: "",
            createdto: "",
        });
        setSelectedCountry(null)
        getItems();
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    }
    const handleCountryChange = (selectedOption) => {
        setSelectedCountry(selectedOption);
    }
    const handleDropDownChange = ({ name, value }) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    };
    const handleMenuAction = (action, rowData) => {
        if (action === 'edit') {
            handleEdit(rowData);
        } else if (action === 'print') {
            // handlePrint(rowData);
        }
        setContextMenu(null); // Close the menu
    };
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div
                    className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}
                >
                    <div className="h6 pt-1">Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? "open" : "closed"}`}>
                    <div
                        className={`border-box2 p-3 ${FilterTab ? "slide-in" : "slide-out"
                            }`}
                    >
                        <div className="form-group grid-contain ">
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Contact ID</label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="contactid"
                                    value={formData.contactid}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Contact No</label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="contactNo"
                                    value={formData.contactNo}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Source</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.source}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'source', value: selectedOption })}
                                    options={sourceList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Type</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.type}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'type', value: selectedOption })}
                                    options={customerTypeList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Nationality</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={selectedCountry}
                                    onChange={handleCountryChange}
                                    options={countriesList?.map(country => ({ value: country, label: country?.name }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Sales Person</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.salesPerson}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'salesPerson', value: selectedOption })}
                                    options={salesPersonList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Name</label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="fullName"
                                    value={formData.fullName}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">Email</label>
                                <input
                                    type="email"
                                    className="p-2 form-control w-75"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-2 start">ID</label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="id"
                                    value={formData.id}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom18" className="form-label">Lead Status</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={formData?.leadStatus}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'leadStatus', value: selectedOption })}
                                    options={leadStatus?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div></div>
                            {/* <div className="d-flex justify-content-around">
                                <div className="d-flex gap-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="followupcheck"
                                        style={{ width: '20px', height: '20px' }}
                                        checked={formData.followupcheck}
                                        onChange={(e) => setFormData(prev => ({ ...prev, followupcheck: e.target.checked }))}
                                    />
                                    <label className="form-check-label" htmlFor="followupcheck">
                                        Followup From
                                    </label>
                                </div>
                                <div className="d-flex">
                                    <DatePicker
                                        selected={formData.followupfrom}
                                        onChange={(date) => handleDateChange({ name: 'followupfrom', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100 datepicker-icon"
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-around">
                                <div className="d-flex gap-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="followtoCheck"
                                        style={{ width: '20px', height: '20px' }}
                                        checked={formData.followtoCheck}
                                        onChange={(e) => setFormData(prev => ({ ...prev, followtoCheck: e.target.checked }))}
                                    />
                                    <label className="form-check-label" htmlFor="taxInclusive">
                                        Followup To
                                    </label>
                                </div>
                                <div className="d-flex">
                                    <DatePicker
                                        selected={formData.followupto}
                                        onChange={(date) => handleDateChange({ name: 'followupto', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100 datepicker-icon"
                                    />
                                </div>
                            </div> */}
                            <div className="d-flex gap-1">
                                <div
                                    onClick={() => getItems()}
                                    className="mainbtnGry flex-end gap-2 w-50"
                                >
                                    <FaFileCircleExclamation
                                        color="#fff"
                                        className="center mt-2 mx-2"
                                    />
                                    <div className="center">Search</div>
                                </div>
                                <div
                                    onClick={() => handleClearFilters()}
                                    className="mainbtnRed flex-end gap-2 w-50"
                                >
                                    <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                            </div>


                            <div className="d-flex justify-content-around">
                                <div className="d-flex gap-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="salecustomer"
                                        style={{ width: '20px', height: '20px' }}
                                        checked={formData.salecustomer}
                                        onChange={(e) => setFormData(prev => ({ ...prev, salecustomer: e.target.checked }))}
                                    />
                                    <label className="form-check-label" htmlFor="salecustomer">
                                        Sale Customer
                                    </label>
                                </div>
                                <div className="d-flex gap-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="leaseCustomer"
                                        style={{ width: '20px', height: '20px' }}
                                        checked={formData.leaseCustomer}
                                        onChange={(e) => setFormData(prev => ({ ...prev, leaseCustomer: e.target.checked }))}
                                    />
                                    <label className="form-check-label" htmlFor="leaseCustomer">
                                        Lease Customer
                                    </label>
                                </div>
                            </div>
                            <div className="d-flex gap-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="prospectlevel"
                                    style={{ width: '20px', height: '20px' }}
                                    checked={formData.prospectlevel}
                                    onChange={(e) => setFormData(prev => ({ ...prev, prospectlevel: e.target.checked }))}
                                />
                                <label className="form-check-label" htmlFor="taxInclusive">
                                    Prospect level
                                </label>
                            </div>
                            {/* <div className="d-flex justify-content-around">
                                <div className="d-flex gap-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="createdfromcheck"
                                        style={{ width: '20px', height: '20px' }}
                                        checked={formData.createdfromcheck}
                                        onChange={(e) => setFormData(prev => ({ ...prev, createdfromcheck: e.target.checked }))}
                                    />
                                    <label className="form-check-label" htmlFor="createdfromcheck">
                                        Created From
                                    </label>
                                </div>
                                <div className="d-flex">
                                    <DatePicker
                                        selected={formData.createdfrom}
                                        onChange={(date) => handleDateChange({ name: 'createdfrom', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100 datepicker-icon"
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-around">
                                <div className="d-flex gap-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="createdtocheck"
                                        style={{ width: '20px', height: '20px' }}
                                        checked={formData.createdtocheck}
                                        onChange={(e) => setFormData(prev => ({ ...prev, createdtocheck: e.target.checked }))}
                                    />
                                    <label className="form-check-label" htmlFor="createdtocheck">
                                        Created To
                                    </label>
                                </div>
                                <div className="d-flex">
                                    <DatePicker
                                        selected={formData.createdto}
                                        onChange={(date) => handleDateChange({ name: 'createdto', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100 datepicker-icon"
                                    />
                                </div>
                            </div> */}
                        </div>
                    </div>

                </div>
            </div>
            <div className="border-box2 p-3">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="d-flex justify-contant-between ">
                            <h5 className="col mainInvHead">Customers List</h5>
                            <div className="d-flex justify-content-end gap-1">
                                <div className="col center">
                                    <button
                                        className="mainbtn "
                                        type="submit"
                                        onClick={() => handlenew()}
                                    >
                                        <IoAddSharp color="#fff" className="center mt-1" />{" "}
                                        <div>Add</div>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="gridshad  mt-3">
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: "#F0EDF5" };
                                        } else {
                                            return { background: "#fff" };
                                        }
                                    }}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                    frameworkComponents={{ BtnCellRenderer }}
                                    context={{ setContextMenu }}
                                />
                            </div>
                            <Pagination
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                pagination={pagination}
                                getItems={getItems}
                            />
                        </div>
                    </>
                )}
            </div>

            {contextMenu && (
                <div
                    style={{
                        position: 'absolute',
                        top: contextMenu.mouseY,
                        left: contextMenu.mouseX,
                        backgroundColor: 'white',
                        border: '1px solid gray',
                        zIndex: 1000,
                        padding: '10px 30px',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 6px rgba(0,0,0,0.2)'
                    }}
                >
                    <div style={{ display: 'grid' }}>
                        <button className="btn btn-secondary " onClick={() => handleMenuAction('edit', contextMenu.data)}>
                            Edit
                        </button>
                        <button className="btn btn-secondary my-2 " onClick={() => handleMenuAction('view', contextMenu.data)}>
                            View
                        </button>
                        <button className="btn btn-secondary " onClick={() => handleMenuAction('delete', contextMenu.data)}>
                            Delete
                        </button>
                    </div>
                </div>
            )}
            <Modal show={previewModal} size="md" onHide={() => setPreviewModal(false)}
                backdrop="static"
                keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Lease</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Modal.Title>Are you sure you want to delete ({selectedRow?.leaseNo})</Modal.Title>
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className="mainbtnRed" onClick={() => setPreviewModal(false)}>Cancel</button>
                    <button className='mainbtn' >Delete</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
class BtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.stopPropagation(); // Prevent row selection
        const { context, data } = this.props;

        if (context && context.setContextMenu) {
            context.setContextMenu({
                mouseX: e.clientX,
                mouseY: e.clientY,
                data: data
            });
        }
    }

    render() {
        return (
            <div className='center pt-1'>
                <span onClick={this.handleClick} style={{ cursor: 'pointer', fontSize: '30px' }}>
                    &#8942; {/* Vertical Ellipsis */}
                </span>
            </div>
        );
    }
}
export default CustomerListing;